export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Après avoir finalisé l'échange, il sera fermé. Les fonds internes seront transférés à l'utilisateur."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir finaliser l'échange?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui, finaliser"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non, garder actif"])}
}